import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type NotificationSettingsFragment = { __typename?: 'NotificationSettingsData', customerId: string, orderId?: string | null, effectiveSendOrderEmails: boolean, kinds: Array<{ __typename?: 'NotificationKindSettingsData', docType: Types.OrderEmailDocType, routedContactType?: Types.ContactType | null, tenantEnabled: boolean, tenantConfigured: boolean, channel: Types.OrderEmailChannel, customerSendChoice: Types.NotificationSendChoice, orderSendChoice: Types.NotificationSendChoice, effectiveSendChoice: Types.NotificationSendChoice, effectiveSends: boolean, derivedRecipients: Array<string>, derivedFallbackReason: Types.CustomerRecipientFallbackReason, customerExcludedEmails: Array<string>, customerAdditionalEmails: Array<string>, orderExcludedEmails: Array<string>, orderAdditionalEmails: Array<string>, effectiveRecipients: Array<string>, textsGoByEmail: boolean, textRecipients: Array<{ __typename?: 'NotificationTextRecipientData', contactId: string, contactName: string, phoneNumber: string }>, customerExcludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }>, orderExcludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }>, documents: Array<{ __typename?: 'NotificationDocumentSettingsData', kind: Types.NotificationDocumentKind, tenantReportId: string, customerReportId?: string | null, effectiveReportId: string }> };

export type GetCustomerNotificationSettingsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerNotificationSettingsQuery = { __typename?: 'Query', customerNotificationSettings?: { __typename?: 'NotificationSettingsData', customerId: string, orderId?: string | null, effectiveSendOrderEmails: boolean, kinds: Array<{ __typename?: 'NotificationKindSettingsData', docType: Types.OrderEmailDocType, routedContactType?: Types.ContactType | null, tenantEnabled: boolean, tenantConfigured: boolean, channel: Types.OrderEmailChannel, customerSendChoice: Types.NotificationSendChoice, orderSendChoice: Types.NotificationSendChoice, effectiveSendChoice: Types.NotificationSendChoice, effectiveSends: boolean, derivedRecipients: Array<string>, derivedFallbackReason: Types.CustomerRecipientFallbackReason, customerExcludedEmails: Array<string>, customerAdditionalEmails: Array<string>, orderExcludedEmails: Array<string>, orderAdditionalEmails: Array<string>, effectiveRecipients: Array<string>, textsGoByEmail: boolean, textRecipients: Array<{ __typename?: 'NotificationTextRecipientData', contactId: string, contactName: string, phoneNumber: string }>, customerExcludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }>, orderExcludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }>, documents: Array<{ __typename?: 'NotificationDocumentSettingsData', kind: Types.NotificationDocumentKind, tenantReportId: string, customerReportId?: string | null, effectiveReportId: string }> } | null };

export type GetOrderNotificationSettingsQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderNotificationSettingsQuery = { __typename?: 'Query', orderNotificationSettings?: { __typename?: 'NotificationSettingsData', customerId: string, orderId?: string | null, effectiveSendOrderEmails: boolean, kinds: Array<{ __typename?: 'NotificationKindSettingsData', docType: Types.OrderEmailDocType, routedContactType?: Types.ContactType | null, tenantEnabled: boolean, tenantConfigured: boolean, channel: Types.OrderEmailChannel, customerSendChoice: Types.NotificationSendChoice, orderSendChoice: Types.NotificationSendChoice, effectiveSendChoice: Types.NotificationSendChoice, effectiveSends: boolean, derivedRecipients: Array<string>, derivedFallbackReason: Types.CustomerRecipientFallbackReason, customerExcludedEmails: Array<string>, customerAdditionalEmails: Array<string>, orderExcludedEmails: Array<string>, orderAdditionalEmails: Array<string>, effectiveRecipients: Array<string>, textsGoByEmail: boolean, textRecipients: Array<{ __typename?: 'NotificationTextRecipientData', contactId: string, contactName: string, phoneNumber: string }>, customerExcludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }>, orderExcludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }>, documents: Array<{ __typename?: 'NotificationDocumentSettingsData', kind: Types.NotificationDocumentKind, tenantReportId: string, customerReportId?: string | null, effectiveReportId: string }> } | null };

export const NotificationSettingsFragmentDoc = new TypedDocumentString(`
    fragment NotificationSettings on NotificationSettingsData {
  customerId
  orderId
  effectiveSendOrderEmails
  kinds {
    docType
    routedContactType
    tenantEnabled
    tenantConfigured
    channel
    customerSendChoice
    orderSendChoice
    effectiveSendChoice
    effectiveSends
    derivedRecipients
    derivedFallbackReason
    customerExcludedEmails
    customerAdditionalEmails
    orderExcludedEmails
    orderAdditionalEmails
    effectiveRecipients
    textRecipients {
      contactId
      contactName
      phoneNumber
    }
    customerExcludedMobiles {
      contactId
      phoneNumber
    }
    orderExcludedMobiles {
      contactId
      phoneNumber
    }
    textsGoByEmail
  }
  documents {
    kind
    tenantReportId
    customerReportId
    effectiveReportId
  }
}
    `, {"fragmentName":"NotificationSettings"});
export const GetCustomerNotificationSettingsDocument = new TypedDocumentString(`
    query GetCustomerNotificationSettings($customerId: String!) {
  customerNotificationSettings(customerId: $customerId) {
    ...NotificationSettings
  }
}
    fragment NotificationSettings on NotificationSettingsData {
  customerId
  orderId
  effectiveSendOrderEmails
  kinds {
    docType
    routedContactType
    tenantEnabled
    tenantConfigured
    channel
    customerSendChoice
    orderSendChoice
    effectiveSendChoice
    effectiveSends
    derivedRecipients
    derivedFallbackReason
    customerExcludedEmails
    customerAdditionalEmails
    orderExcludedEmails
    orderAdditionalEmails
    effectiveRecipients
    textRecipients {
      contactId
      contactName
      phoneNumber
    }
    customerExcludedMobiles {
      contactId
      phoneNumber
    }
    orderExcludedMobiles {
      contactId
      phoneNumber
    }
    textsGoByEmail
  }
  documents {
    kind
    tenantReportId
    customerReportId
    effectiveReportId
  }
}`);
export const GetOrderNotificationSettingsDocument = new TypedDocumentString(`
    query GetOrderNotificationSettings($orderId: String!) {
  orderNotificationSettings(orderId: $orderId) {
    ...NotificationSettings
  }
}
    fragment NotificationSettings on NotificationSettingsData {
  customerId
  orderId
  effectiveSendOrderEmails
  kinds {
    docType
    routedContactType
    tenantEnabled
    tenantConfigured
    channel
    customerSendChoice
    orderSendChoice
    effectiveSendChoice
    effectiveSends
    derivedRecipients
    derivedFallbackReason
    customerExcludedEmails
    customerAdditionalEmails
    orderExcludedEmails
    orderAdditionalEmails
    effectiveRecipients
    textRecipients {
      contactId
      contactName
      phoneNumber
    }
    customerExcludedMobiles {
      contactId
      phoneNumber
    }
    orderExcludedMobiles {
      contactId
      phoneNumber
    }
    textsGoByEmail
  }
  documents {
    kind
    tenantReportId
    customerReportId
    effectiveReportId
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerNotificationSettings: build.query<GetCustomerNotificationSettingsQuery, GetCustomerNotificationSettingsQueryVariables>({
      query: (variables) => ({ document: GetCustomerNotificationSettingsDocument, variables })
    }),
    GetOrderNotificationSettings: build.query<GetOrderNotificationSettingsQuery, GetOrderNotificationSettingsQueryVariables>({
      query: (variables) => ({ document: GetOrderNotificationSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerNotificationSettingsQuery, useLazyGetCustomerNotificationSettingsQuery, useGetOrderNotificationSettingsQuery, useLazyGetOrderNotificationSettingsQuery } = injectedRtkApi;
